import { HEADER_MENU } from "@model/components/componentMeta.model";
import { genUniqKey } from "@helpers/component.helper";
import { replaceDeep } from "@helpers/object.helper";

const create = (customID, customComponent = {}, siteComponents) => {
  // will use
  genUniqKey;
  siteComponents;
  // const id = customID ? customID : genUniqKey(siteComponents, HEADER_MENU.prefixKey); 

  // will delete
  let id = customID;
  if (id === undefined || id === null || id === '') {
    const randomkey = `${HEADER_MENU.prefixKey}${Math.random().toString(36).substring(4)}`; 
    id = `${HEADER_MENU.prefixKey}${randomkey.substring(randomkey.length - 4, randomkey.length)}`;
  }

  let component = {
    type: HEADER_MENU.type,
    id: id,
    properties: {
      name: 'Menu',
      isEnable: true,
      link: {
        type: "url",
        urlIsEnable: true,
        url: "https://www.makewebeasy.com",
        pageID: null,
        sectionPageID: null,
        sectionID: null,
        target: "_blank",
      },
    },
    componentsID: [],
  };

  return customComponent ? replaceDeep(component, customComponent) : component;
};

export { create };
export default { create };
